import { motion } from 'framer-motion';
import { AppWrap, MotionWrap } from '../../wrapper';
import { useEffect, useMemo, useState } from 'react';
import { client } from '../../client';

const ease = [0.22, 1, 0.36, 1];

const Education = () => {
  const [educations, setEducations] = useState([]);

  useEffect(() => {
    const query = '*[_type == "workExperience"]';
    client.fetch(query).then((data) => setEducations(data));
  }, []);

  const sortedEducations = useMemo(() => {
    const parseEndYear = (str = '') => {
      const parts = str.split('-').map((s) => s.trim().toLowerCase());
      const end = parts[1] || parts[0] || '';
      if (end === 'present') return 9999;
      const n = parseInt(end, 10);
      return Number.isFinite(n) ? n : 0;
    };

    return [...educations].sort((a, b) => parseEndYear(b.year) - parseEndYear(a.year));
  }, [educations]);

  return (
    <section className="mx-auto w-full max-w-5xl px-5 py-12 sm:px-8 sm:py-16 lg:px-12 lg:py-20">
      <div className="max-w-[64ch]">
        <p className="mb-3 text-[0.85rem] uppercase tracking-[0.12em] text-black/60">
          Academic
        </p>

        <h2 className="text-3xl font-semibold tracking-[-0.02em] text-black/90 sm:text-4xl">
          Education
        </h2>
      </div>

      <div className="mt-10 grid gap-6">
        {sortedEducations.map((education) => (
          <motion.article
            key={education._id}
            initial= {{ opacity: 0, y: 12 }}
            whileInView= {{ opacity: 1, y: 0 }}
            viewport= {{ once: true, amount: 0.25 }}
            transition= {{ duration: 0.55, ease }}
            className="rounded-2xl border border-black/10 bg-white/60 p-5 sm:p-6"
          >
            <div className="flex flex-wrap items-baseline justify-between gap-3">
              <h4 className="text-base font-semibold text-black/90">
                {education.name}
              </h4>

              <p className="text-sm text-black/60">{education.company}</p>
            </div>

            <p className="mt-2 text-xs uppercase tracking-[0.12em] text-black/60">
              {education.year}
            </p>

            <p className="mt-4 text-sm leading-relaxed text-black/75">
              {education.desc}
            </p>
          </motion.article>
        ))}
      </div>
    </section>
  );
};

export default AppWrap(MotionWrap(Education, 'app__education'), 'education', 'app__primarybg');